import { css } from '@emotion/react'
import { Theme } from '@mui/material/styles'

export const button = css`
  border-radius: 12px;
`

export const modal = css`
  display: flex;
  align-items: center;
  justify-content: center;

  .container {
    width: fit-content;
  }
`

export const modalContent = css`
  overflow: auto;

  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const modalHeader = css`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const title = css`
  font-size: 18px;
  font-weight: 700;
  line-height: normal;
`

export const description = css`
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
`

export const otpInputContainer = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`

const getBorderColor = (theme: Theme, hasError: boolean, hasValue: boolean) => {
  if (hasError) {
    return theme.colors.red
  }
  if (hasValue) {
    return theme.colors.blue
  }
  return theme.colors.backgroundOne
}

export const otpInputBase = (theme: Theme, hasError: boolean, hasValue: boolean) => css`
  width: 82px !important;
  height: 82px;
  border-radius: 8px;
  border: 1px solid ${getBorderColor(theme, hasError, hasValue)};
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  transition: border-color 200ms, box-shadow 200ms;

  /* Hide number input spinner controls */
  -moz-appearance: textfield;
  -webkit-appearance: none;

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:hover:not(:disabled) {
    border-color: ${hasError ? theme.colors.red : theme.colors.blue};
  }

  &:focus:not(:disabled) {
    border-color: ${hasError ? theme.colors.red : theme.colors.blue};
    box-shadow: 0 0 0 2px ${hasError ? theme.colors.red : theme.colors.blue}33;
    outline: none;
  }

  &:disabled {
  }

  ${theme.breakpoints.down(768)} {
    width: 42px !important;
    height: 42px;
  }
`

export const otpErrorText = css`
  width: 100%;
  margin-top: 4px;

  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
`

export const buttonsContainer = css`
  display: flex;
  gap: 15px;
`

export const resendCodeContainer = css`
  display: block;
  width: 100%;
  text-align: center;
`

export const resendCodeText = css`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
`

export const textButton = css`
  padding: 0;
  min-width: fit-content;
  height: auto;
  cursor: pointer;

  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`
